import { defineStore } from "pinia";

import integrationsApi from "@/services/api/integrationsApi";

import { useNotificationStore } from "@/stores/notificationStore";
import { getCompanyId } from "@/utils/userUtils";

export const useIntegrationStore = defineStore("integration", {
  state: () => ({
    integrations: [],
    companyId: getCompanyId(),
    dataIsLoading: false,
    isSubmitting: false,
  }),

  getters: {
    sabyIntegrations: (state) =>
      state.integrations.filter(
        (integration) =>
          integration.provider_type === "Integration::Saby"
      ),
  },

  actions: {
    normalizeResponseData(response) {
      return response.data.result || response.data || [];
    },

    async fetchIntegrations() {
      this.dataIsLoading = true;
      try {
        const response = await integrationsApi.index(this.companyId);
        this.integrations = this.normalizeResponseData(response);
      } finally {
        this.dataIsLoading = false;
      }
    },

    async createIntegration(payload) {
      this.isSubmitting = true;
      try {
        const response = await integrationsApi.create(
          this.companyId,
          payload
        );
        const integration = this.normalizeResponseData(response);
        this.integrations.unshift(integration);
        useNotificationStore().showSuccess("Интеграция успешно добавлена");
        return integration;
      } finally {
        this.isSubmitting = false;
      }
    },

    async updateIntegration(id, payload) {
      this.isSubmitting = true;
      try {
        const response = await integrationsApi.update(
          this.companyId,
          id,
          payload
        );
        const integration = this.normalizeResponseData(response);
        this.replaceIntegration(integration);
        useNotificationStore().showSuccess("Интеграция Saby обновлена");
        return integration;
      } finally {
        this.isSubmitting = false;
      }
    },

    async enableIntegration(id) {
      this.isSubmitting = true;
      try {
        const response = await integrationsApi.enableIntegration(
          this.companyId,
          id
        );
        const integration = this.normalizeResponseData(response);
        this.replaceIntegration(integration);
        useNotificationStore().showSuccess("Интеграция включена");
        return integration;
      } finally {
        this.isSubmitting = false;
      }
    },

    async disableIntegration(id) {
      this.isSubmitting = true;
      try {
        const response = await integrationsApi.disableIntegration(
          this.companyId,
          id
        );
        const integration = this.normalizeResponseData(response);
        this.replaceIntegration(integration);
        useNotificationStore().showSuccess("Интеграция отключена");
        return integration;
      } finally {
        this.isSubmitting = false;
      }
    },

    async toggleIntegration(integration) {
      if (integration.enabled) {
        return this.disableIntegration(integration.id);
      }

      return this.enableIntegration(integration.id);
    },

    replaceIntegration(integration) {
      const index = this.integrations.findIndex(
        (item) => item.id === integration.id
      );

      if (index === -1) {
        this.integrations.unshift(integration);
      } else {
        this.integrations.splice(index, 1, integration);
      }
    },
  },
});
